<template>
  <div class="elementor-element elementor-element-5d26858 e-flex e-con-boxed e-con e-parent e-lazyloaded"
       data-id="5d26858"
       data-element_type="container"
       data-e-type="container">
    <div class="e-con-inner">
      <div class="elementor-element elementor-element-ebdc128 elementor-widget elementor-widget-heading"
           data-id="ebdc128"
           data-element_type="widget"
           data-e-type="widget"
           data-widget_type="heading.default">
        <h2 class="elementor-heading-title elementor-size-default">
          {{ bestsellerTitle }}
        </h2>
      </div>
      <div class="elementor-element elementor-element-6029111 elementor-widget elementor-widget-jet-listing-grid"
           data-id="6029111"
           data-element_type="widget"
           data-e-type="widget"
           data-settings="{&quot;columns&quot;:&quot;4&quot;,&quot;columns_tablet&quot;:&quot;3&quot;,&quot;columns_mobile&quot;:&quot;2&quot;}"
           data-widget_type="jet-listing-grid.default">
        <div class="jet-listing-grid jet-listing">
          <div class="jet-listing-grid__items grid-col-desk-4 grid-col-tablet-3 grid-col-mobile-2 jet-listing-grid--200"
               data-queried-id="12|WP_Post"
               data-nav="{&quot;enabled&quot;:false,&quot;type&quot;:null,&quot;more_el&quot;:null,&quot;query&quot;:[],&quot;widget_settings&quot;:{&quot;lisitng_id&quot;:200,&quot;posts_num&quot;:8,&quot;columns&quot;:4,&quot;columns_tablet&quot;:3,&quot;columns_mobile&quot;:2,&quot;column_min_width&quot;:240,&quot;column_min_width_tablet&quot;:240,&quot;column_min_width_mobile&quot;:240,&quot;inline_columns_css&quot;:false,&quot;is_archive_template&quot;:&quot;&quot;,&quot;post_status&quot;:[&quot;publish&quot;],&quot;use_random_posts_num&quot;:&quot;&quot;,&quot;max_posts_num&quot;:9,&quot;not_found_message&quot;:&quot;No data was found&quot;,&quot;is_masonry&quot;:false,&quot;equal_columns_height&quot;:&quot;&quot;,&quot;use_load_more&quot;:&quot;&quot;,&quot;load_more_id&quot;:&quot;&quot;,&quot;load_more_type&quot;:&quot;click&quot;,&quot;load_more_offset&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0,&quot;sizes&quot;:[]},&quot;use_custom_post_types&quot;:&quot;&quot;,&quot;custom_post_types&quot;:[],&quot;hide_widget_if&quot;:&quot;&quot;,&quot;carousel_enabled&quot;:&quot;&quot;,&quot;slides_to_scroll&quot;:&quot;1&quot;,&quot;arrows&quot;:&quot;true&quot;,&quot;arrow_icon&quot;:&quot;fa fa-angle-left&quot;,&quot;dots&quot;:&quot;&quot;,&quot;autoplay&quot;:&quot;true&quot;,&quot;pause_on_hover&quot;:&quot;true&quot;,&quot;autoplay_speed&quot;:1500,&quot;infinite&quot;:&quot;true&quot;,&quot;center_mode&quot;:&quot;true&quot;,&quot;effect&quot;:&quot;slide&quot;,&quot;speed&quot;:500,&quot;inject_alternative_items&quot;:&quot;&quot;,&quot;injection_items&quot;:[],&quot;scroll_slider_enabled&quot;:&quot;&quot;,&quot;scroll_slider_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;,&quot;mobile&quot;],&quot;custom_query&quot;:false,&quot;custom_query_id&quot;:&quot;&quot;,&quot;_element_id&quot;:&quot;&quot;,&quot;collapse_first_last_gap&quot;:false,&quot;list_tag_selection&quot;:&quot;&quot;,&quot;list_items_wrapper_tag&quot;:&quot;div&quot;,&quot;list_item_tag&quot;:&quot;div&quot;,&quot;empty_items_wrapper_tag&quot;:&quot;div&quot;}}"
               data-page="1"
               data-pages="1"
               data-listing-source="posts"
               data-listing-id="200"
               data-query-id="">
            <div v-for="item in goodsData"
                 :key="item.id"
                 class="jet-listing-grid__item"
                 :class="'jet-listing-dynamic-post-' + item.id"
                 :data-post-id="item.id">
              <div data-elementor-type="jet-listing-items"
                   data-elementor-id="200"
                   class="elementor elementor-200"
                   data-elementor-post-type="jet-engine">
                <div class="elementor-element elementor-element-e394b6b animated-fast e-flex e-con-boxed e-con e-parent e-lazyloaded animated fadeIn"
                     data-id="e394b6b"
                     data-element_type="container"
                     data-e-type="container"
                     data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;animation&quot;:&quot;fadeIn&quot;}">
                  <div class="e-con-inner">
                    <div class="elementor-element elementor-element-9dd909d elementor-widget__width-inherit elementor-widget elementor-widget-image"
                         data-id="9dd909d"
                         data-element_type="widget"
                         data-e-type="widget"
                         data-widget_type="image.default">
                      <a target="_blank"
                         rel="nofollow noopener">
                        <img decoding="async"
                             width="300"
                             height="300"
                             loading="lazy"
                             :src="item.goodsImage"
                             class="attachment-medium"
                             alt=""
                             sizes="(max-width: 300px) 100vw, 300px">
                      </a>
                    </div>
                    <div class="elementor-element elementor-element-44282c1 elementor-widget elementor-widget-heading"
                         data-id="44282c1"
                         data-element_type="widget"
                         data-e-type="widget"
                         data-widget_type="heading.default">
                      <h3 class="elementor-heading-title elementor-size-default">
                        {{ item.goodsName }}
                      </h3>
                    </div>
                    <div class="elementor-element elementor-element-467247f elementor-widget elementor-widget-heading"
                         data-id="467247f"
                         data-element_type="widget"
                         data-e-type="widget"
                         data-widget_type="heading.default">
                      <div class="elementor-heading-title elementor-size-default">
                        {{ item.price }} {{ item.currencySymbol || '$' }}
                      </div>
                    </div>
                    <div class="elementor-element elementor-element-da84a8a elementor-align-justify elementor-widget__width-inherit elementor-widget elementor-widget-button"
                         data-id="da84a8a"
                         data-element_type="widget"
                         data-e-type="widget"
                         data-widget_type="button.default"
                         style="padding-bottom: 15px;">
                      <span class="elementor-button elementor-button-link elementor-size-sm"
                            rel="nofollow noopener"
                            @click="handleBuyNow(item)">
                        <span class="elementor-button-content-wrapper">
                          <span class="elementor-button-text">
                            Buy on {{ selectPlatform.platformName }}
                          </span>
                        </span>
                      </span>
                    </div>
                    <!-- 暂未开放 CNfans 购买 -->
                    <!-- <div
                      class="elementor-element elementor-element-4934e3e elementor-align-justify elementor-widget__width-inherit elementor-widget elementor-widget-button"
                      data-id="4934e3e"
                      data-element_type="widget"
                      data-e-type="widget"
                      data-widget_type="button.default"
                    >
                      <a
                        class="elementor-button elementor-size-sm"
                        role="button"
                      >
                        <span
                          class="elementor-button-content-wrapper"
                        >
                          <span
                            class="elementor-button-text"
                          >
                            Buy on
                            CNfans
                          </span>
                        </span>
                      </a>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { openPlatformBuy, reportGoodsClick } from '@/utils/goodsAction'

export default {
  name: 'Bestseller',

  props: {
    goodsData: {
      type: Array,
      default: () => [],
    },

    selectPlatform: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      bestsellerTitle: 'BEST SELLER'
    }
  },

  methods: {
    //立即购买
    handleBuyNow(goods) {
      reportGoodsClick(goods)
      openPlatformBuy(this.selectPlatform, goods)
    }
  }
}
</script>
